import CollaterateInputErrorList from './CollaterateInputErrorList';

const CLIENT_VALIDATION_STATUS = 400;

/**
 * Build a {@link CollaterateInputErrorList CollaterateInputErrorList} for a validation failure the SDK
 * detected itself, rather than one the API reported.
 *
 * The shape matches what the API returns for the same class of problem, so consumers only need one
 * catch path whether the rejection came from the SDK or the server.
 *
 * @param {Array<{field: string, message: string}>} errors - The failures to report.
 * @returns {CollaterateInputErrorList}
 */

export default function clientInputError (errors) {
    return new CollaterateInputErrorList({
        errors: errors.map(({ field, message }) => ({
            detail: message,
            title: 'Invalid input',
            code: 'SDK-VALIDATION',
            status: CLIENT_VALIDATION_STATUS,
            source: { parameter: field },
        })),
    });
}
